import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function ServiceWhySixWeeks() {
  return <section className="w-full bg-brand-warm-white py-12 md:py-14 px-4 sm:px-6 lg:px-8" data-id="element-343" data-mp="2utfsfuggmqds">
      <div className="max-w-4xl mx-auto" data-id="element-344" data-mp="2fvvrqzqljhdf">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-10" data-id="element-345" data-mp="2fwxei1gz5saz">
          Why not just do a one-day workshop?
        </h2>
        <p className="text-xl md:text-2xl text-brand-gray leading-relaxed mb-16" data-id="element-346" data-mp="2kwjsid4mncku">
          Because it doesn't stick. Your team needs time between sessions to try
          things, hit walls, and figure out what actually works in their
          day-to-day. That cycle of learn, apply, come back with questions.
          That's where real capability gets built.
        </p>

        <div className="relative bg-brand-navy p-10 md:p-14 rounded-lg mt-20 shadow-lg" data-id="element-347" data-mp="33rrsso74p2jf">
          <div className="absolute -top-8 left-10 bg-brand-orange p-4 rounded-full shadow-md" data-id="element-348" data-mp="3rhm4v3jmin2m">
            <QuoteIcon className="w-8 h-8 text-white" data-id="element-349" data-mp="59iq9dp65tr" />
          </div>
          <blockquote className="text-2xl md:text-3xl text-white leading-relaxed font-medium italic mb-10 mt-6" data-id="element-350" data-mp="1am4v3iwmqtu3">
            "If I could recommend doing it the way we did, like two hour chunks
            every week over six weeks, that was what delivered the most value.
            If I had done it all in one chunk in a day, they would have been
            fried."
          </blockquote>
          <div className="flex items-center" data-id="element-351" data-mp="1tcwap277nggx">
            <div data-id="element-352" data-mp="1tbkx6anyqucm">
              <div className="font-bold text-white text-xl mb-1" data-id="element-353" data-mp="1tf8qp9tergrc">
                Pali Dhanoya
              </div>
              <div className="text-brand-orange text-lg" data-id="element-354" data-mp="23blmqecfe6p9">
                Head of Product, HTEC Group
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}